import React, { Component } from 'react';
import './FAQ.css';

class FAQ extends Component {
  render() {
    return (
      <div className="faq">
        <div className="faq__body">
          <div className="faq__title content__large">
            <a className="faq__title-anchor" name="faq" aria-label="faq">
              FAQ
            </a>
          </div>

          <div className="faq__question">Q: What is this?</div>
          <div className="faq__answer">
            A: If you sold any cryptocurrency last year, you'll need to pay the
            tax man on the gains. Moon Tax generates the 8949 tax form for you.
          </div>

          <div className="faq__question">Q: How do I use it?</div>
          <div className="faq__answer">
            A: Log into your Coinbase account and export a CSV file of all your
            past transactions. Upload the file to Moon Tax and we'll give you
            back the populated tax form.
          </div>

          <div className="faq__question">
            Q: Which exchanges can I import data from?
          </div>
          <div className="faq__answer">A: Coinbase.</div>

          <div className="faq__question">
            Q: Will you be adding additional exchanges?
          </div>
          <div className="faq__answer">A: Absolutely. Stay tuned.</div>

          <div className="faq__question">
            Q: What if I used more exchanges than just Coinbase?
          </div>
          <div className="faq__answer">
            A: Moon Tax will not work for you this year. This feature will be
            available next year - bookmark this page!
          </div>

          <div className="faq__question">Q: Do you store any of my data?</div>
          <div className="faq__answer">
            A: Nope. We're not interested in monetizing your data, the security
            headache of storing it, or paying for the storage.
          </div>

          <div className="faq__question">
            Q: Why doesn't this cost anything?
          </div>
          <div className="faq__answer">
            A: It may in the future, but for now, we're interested in user
            feedback and building a useful tool. Donations help us keep the
            lights on; see below.
          </div>

          <div className="faq__question">
            Q: Are you sure you don't want to add a disclaimer?
          </div>
          <div className="faq__answer">
            A: Oh, wait. Yes. This project was taken seriously, but by using it
            you're agreeing not to hold us legally responsible for anything
            crumby that comes as a result. Please a consult a human tax
            professional if you want sound legal advice.
          </div>
        </div>
      </div>
    );
  }
}

export default FAQ;



// WEBPACK FOOTER //
// ./src/FAQ.js